import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isDebugModeActive } from '../../../helpers/error';
import { isSSR } from '@front10/utils';

const customStyle = {
  display: 'none'
};

const titleStyle = {
  fontSize: '22px',
  fontWeight: 'bold'
};

const CriticalError = (props) => {
  const { content, forceDebug, meta } = props;
  const [debugModeActive, setDebugModeActive] = useState(false);
  const errorObj = JSON.parse(content);

  // Triggering a re-render cause React SSR reconciliation algorithm
  // https://github.com/facebook/react/issues/11128
  useEffect(() => {
    if (!debugModeActive && isDebugModeActive(forceDebug)) {
      setDebugModeActive(true);
    }
  }, [debugModeActive, forceDebug]);

  if (debugModeActive) {
    customStyle.display = 'block';
  }

  return (
    <section className="fr-debug-helper" style={customStyle}>
      {isSSR() && !errorObj.traceMode && (
        <span style={titleStyle}>Server Side Rendering(SSR) Error</span>
      )}
      {isSSR() && errorObj.traceMode && (
        <span style={titleStyle}>Server Side Rendering(SSR) Tracing</span>
      )}
      {!isSSR() && <span style={titleStyle}>Client Side Error</span>}
      <p>
        <strong>Meta:</strong>
        <span>
          {meta.moduleId}
          {'/'}
          {meta.name}
          {'/'}
          {meta.version}
        </span>
      </p>
      <p>
        <strong>Date:</strong>
        {errorObj.date}
      </p>
      <p>
        <strong>Message:</strong>
        {errorObj.message}
      </p>
      <p>
        <strong>Stack:</strong>
        {errorObj.stack}
      </p>
      {errorObj.cmpConfig && (
        <div>
          <strong>Input cmpConfig:</strong>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <br />
            {JSON.stringify(errorObj.cmpConfig)}
          </details>
        </div>
      )}
      {!errorObj.traceMode && (
        <div>
          <strong>Complete Error:</strong>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <br />
            {content}
          </details>
        </div>
      )}
    </section>
  );
};

CriticalError.propTypes = {
  /**
   * We don't want a deep Error object messing around
   * so this property must be a string
   * Tip: You can pass an stringified version of an object here
   */
  content: PropTypes.string,
  /**
   * Bypass the url hash impure mechanism
   */
  forceDebug: PropTypes.bool,
  /**
   * Component meta props like: name, moduleId, version
   */
  meta: PropTypes.shape({
    name: PropTypes.string,
    moduleId: PropTypes.string,
    version: PropTypes.string
  })
};
CriticalError.defaultProps = {
  content: 'NO_ERROR_CAPTURED',
  meta: {},
  forceDebug: false
};

CriticalError.componentName = 'CriticalError';

export default CriticalError;
